import { ShoppingCart } from "lucide-react";

export const AdminOrdersTab = ({ orders }) => {
  return (
    <div className="space-y-6">
      <p className="text-slate-500">{orders.length} orders</p>
      {orders.length === 0 ? (
        <div className="bg-white rounded-xl border border-slate-200 p-12 text-center">
          <ShoppingCart className="h-12 w-12 text-slate-300 mx-auto mb-4" />
          <p className="text-slate-500">No orders yet</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Order ID</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Customer</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Amount</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {orders.map((order, idx) => (
                <tr key={order.order_id} data-testid={`admin-order-${idx}`}>
                  <td className="px-6 py-4 font-mono text-sm">{order.order_id}</td>
                  <td className="px-6 py-4 text-sm text-slate-600">{order.customer_id}</td>
                  <td className="px-6 py-4 font-semibold">£{order.total_amount?.toFixed(2)}</td>
                  <td className="px-6 py-4">
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      order.status === "paid" ? "bg-emerald-100 text-emerald-700" :
                      order.status === "shipped" ? "bg-blue-100 text-blue-700" :
                      order.status === "delivered" ? "bg-green-100 text-green-700" :
                      "bg-amber-100 text-amber-700"
                    }`}>{order.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export const AdminTransactionsTab = ({ transactions }) => {
  return (
    <div className="space-y-6">
      <p className="text-slate-500">{transactions.length} transactions</p>
      {transactions.length === 0 ? (
        <div className="bg-white rounded-xl border border-slate-200 p-12 text-center">
          <span className="h-12 w-12 text-slate-300 mx-auto mb-4 block text-4xl">💳</span>
          <p className="text-slate-500">No transactions yet</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Transaction ID</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Amount</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Status</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Payment Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {transactions.map((txn, idx) => (
                <tr key={txn.transaction_id} data-testid={`admin-txn-${idx}`}>
                  <td className="px-6 py-4 font-mono text-sm">{txn.transaction_id}</td>
                  <td className="px-6 py-4 font-semibold">£{txn.amount?.toFixed(2)} {txn.currency?.toUpperCase()}</td>
                  <td className="px-6 py-4">
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      txn.status === "paid" || txn.status === "processed" ? "bg-emerald-100 text-emerald-700" :
                      txn.status === "initiated" ? "bg-blue-100 text-blue-700" :
                      "bg-slate-100 text-slate-700"
                    }`}>{txn.status}</span>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      txn.payment_status === "paid" ? "bg-emerald-100 text-emerald-700" :
                      txn.payment_status === "pending" ? "bg-amber-100 text-amber-700" :
                      "bg-slate-100 text-slate-700"
                    }`}>{txn.payment_status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
